import {
    CompanySubscriptionConfig,
    CreditSubscriptionConfig,
    DesignerSubscriptionConfig,
    Subscription,
    SubscriptionConfig,
    SubscriptionFromSubscriptionType,
    SubscriptionType,
} from 'models';

import { SubscriptionHelpers } from './SubscriptionHelpers';

export const SubscriptionConfigHelpers = {
    getSubscriptionConfig: (subscription: Subscription) => {
        const { type } = SubscriptionHelpers.getSubscriptionAndType(subscription);

        return SubscriptionConfigHelpers.getSubscriptionConfigByType(type)[subscription];
    },

    getSubscriptionConfigByType: <T extends SubscriptionType>(
        type: T,
    ): Record<SubscriptionFromSubscriptionType<T>, SubscriptionConfig> => {
        switch (type) {
            case SubscriptionType.COMPANY:
                return CompanySubscriptionConfig as Record<SubscriptionFromSubscriptionType<T>, SubscriptionConfig>;

            case SubscriptionType.DESIGNER:
                return DesignerSubscriptionConfig as Record<SubscriptionFromSubscriptionType<T>, SubscriptionConfig>;

            case SubscriptionType.CREDIT:
                return CreditSubscriptionConfig as Record<SubscriptionFromSubscriptionType<T>, SubscriptionConfig>;
        }
    },

    // This function is more of a SubscriptionHelper, but would break the dep chain
    // SubscriptionConfigHelpers -> SubscriptionHelpers -> SubscriptionTypes
    isDowngrade: <T extends SubscriptionType>(
        type: T,
        from?: SubscriptionFromSubscriptionType<T>,
        to?: SubscriptionFromSubscriptionType<T>,
    ): boolean => {
        if (!from || !to) {
            return false;
        }

        assertFromAndToAreOfSameType(type, from, to);

        const config = SubscriptionConfigHelpers.getSubscriptionConfigByType(type);

        return config[to].score < config[from].score;
    },
};

const assertFromAndToAreOfSameType = <T extends SubscriptionType>(
    type: T,
    from: SubscriptionFromSubscriptionType<T>,
    to: SubscriptionFromSubscriptionType<T>,
) => {
    const { type: fromType } = SubscriptionHelpers.getSubscriptionAndType(from);
    const { type: toType } = SubscriptionHelpers.getSubscriptionAndType(to);

    console.assert(fromType === toType, 'From and To subscriptions must be of the same type');
    console.assert(fromType === type, `From subscription must be of type ${type}`);
    console.assert(toType === type, `To subscription must be of type ${type}`);
};
